module.exports = __webpack_public_path__ + "img/19-2.b5a35af2.jpg";